/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCarFan2 = createReactComponent("outline", "car-fan-2", "IconCarFan2", [["path", { "d": "M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z", "key": "svg-0" }], ["path", { "d": "M14.044 14.624l-2.044 -2.624h4", "key": "svg-1" }], ["path", { "d": "M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z", "key": "svg-2" }], ["path", { "d": "M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z", "key": "svg-3" }], ["path", { "d": "M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-4" }]]);

export { IconCarFan2 as default };
//# sourceMappingURL=IconCarFan2.mjs.map
